import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'theme/variables.css';
import 'theme/colors.css';
import 'theme/typography.css';
import 'theme/bridge.css';
import 'assets/css/styles.css';
import "react-widgets/styles.css";

import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
